import { Paragraph2, Paragraph1 } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import { Device } from '../../../../../common/Device';

import * as styles from './styles.css';

export interface ICustomFieldView {
  label: string;
  value: React.ReactText;
  className?: string;
}

export const CustomFieldView: React.FC<ICustomFieldView> = ({ label, value, className }) => (
  <div className={classNames(styles['root'], className)}>
    <Device
      desktop={
        <div className={styles['field']}>
          <div className={styles['label']}>
            <Paragraph2>{label}</Paragraph2>
          </div>
          <div className={styles['value']}>
            <Paragraph2>{value}</Paragraph2>
          </div>
        </div>
      }
      mobile={
        <div className={classNames(styles['field'], styles['mobile'])}>
          <div className={classNames(styles['label'], styles['mobile'])}>
            <Paragraph2 color="black_60">{label}</Paragraph2>
          </div>
          <div className={classNames(styles['value'], styles['mobile'])}>
            <Paragraph1>{value}</Paragraph1>
          </div>
        </div>
      }
    />
  </div>
);

CustomFieldView.displayName = 'CustomFieldView';
